var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-x-twitter';
                    var viewUrl = 'gfx/sprite.svg#view-icon-x-twitter';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };